import { apiClient } from '../../../v4/core/apiClient';
import { createCalloutsApi } from './callouts.api.http';

export const myCalloutsApi = createCalloutsApi(apiClient);
